module.exports = __webpack_public_path__ + "img/login-button-l.e69d0d6b.svg";